import httpService from '@/core/http-service'

function getCaseStatisticsOverTime() {
  return httpService.get('rpc/analytics/caseStatisticsOverTime')
}

function getActiveCasesByWorkType() {
  return httpService.get('rpc/analytics/activeCasesByWorkType')
}

export default { getCaseStatisticsOverTime, getActiveCasesByWorkType }
